{
  "credits": {
    "ledger": {
      "signupGift": "Cadeau de bienvenue",
      "topUp": "Recharge de {{amount}} {{coin}}",
      "storePurchase": "Achat de {{amount}} {{coin}} via {{store}}",
      "giftCode": "Code cadeau {{code}}",
      "prize": "Gain de la roue de la chance",
      "gift": "Crédit offert",
      "stores": {
        "bazaar": "Cafe Bazaar"
      }
    }
  }
}
